/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ComponentBase from '../../ComponentBase';
import GoogleAnalytics from '../../GoogleAnalytics';
import InjectableComponent from '../ComponentReference/InjectableComponent';
import KeyShortcutComponent from '../KeyShortcutComponent';
import IPopupManager from './IPopupManager';
import { ContextKey } from '../Configurator/ContextKey';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

enum PopupCloseOption
{
    None = 0,
    CloseIfOpen = 1,
    CloseIfPageOpen = 2
}

// tslint:disable-next-line:typedef
let ccPopupCloseOption = cc.Enum(PopupCloseOption);
export { PopupCloseOption, ccPopupCloseOption };

@cc._decorator.ccclass
export default class PopupDispatcher extends ComponentBase
{
    /** [[PopupManager]] reference to dispatch popup request to. */
    @property({ type: InjectableComponent, visible: true })
    private _popupManagerRef: InjectableComponent<IPopupManager> = new InjectableComponent<IPopupManager>();

    /** Name of the PageView node in the canvas element. */
    @property({ visible: true })
    private _pageViewNodeName: string = "";

    /** Public getter for PageView node. */
    public get PageViewNodeName(): string { return this._pageViewNodeName; }

    /** If true, will hide [[PopupManager]] if already displayed. */
    @property({ type: ccPopupCloseOption })
    protected closeOption: PopupCloseOption = PopupCloseOption.CloseIfOpen;

    /** Optional keyShortCut that will dispatch This. */
    @property({ type: KeyShortcutComponent, visible: true })
    private _keyShortcut: KeyShortcutComponent = null;

    /** @hidden */
    protected setContexts(): void
    {
        this._popupManagerRef.SetContext(ContextKey.POPUP_MANAGER);
    }

    /** @hidden */
    protected onLoad(): void
    {
        super.onLoad();

        this.node.on(cc.Node.EventType.TOUCH_END, this.touchEndHandler);
        if (this._keyShortcut)
        {
            cc.systemEvent.on(cc.SystemEvent.EventType.KEY_DOWN, this.onKeyDown, this);
        }
    }

    /** Handler for dispatching popup on touch end. */
    private touchEndHandler = (): void =>
    {
        if (!this.enabled) { return; }

        this._popupManagerRef.Value.ShowPopup(this._pageViewNodeName, this.closeOption);
        GoogleAnalytics.ClickEvent(this.node.name);
    }

    /** Handler for dispatching popup on key down. */
    public onKeyDown(event): void
    {
        if (!this._keyShortcut || event.keyCode !== this._keyShortcut.Key) { return; }

        this.touchEndHandler();
    }
}
